import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Company } from "../types";

export const useActiveCompany = () => {
  const params = useParams();

  const [activeCompanyId, setActiveCompanyId] = useState<
    Company["Id"] | undefined
  >(undefined);

  useEffect(() => {
    setActiveCompanyId(Number(params.companyId));
  }, [params.companyId]);

  // Un id non positivo (es. segnaposto `-1` o `NaN` durante la navigazione)
  // viene normalizzato a `undefined`, così le guardie `enabled: !!activeCompany`
  // degli hook non lasciano partire chiamate API con `companyId=-1`.
  return activeCompanyId && activeCompanyId > 0 ? activeCompanyId : undefined;
};
